module.exports = __webpack_public_path__ + "static/media/botao-medico_tutor.7412d6e0.png";